import { render, staticRenderFns } from "./ClingenApp.vue?vue&type=template&id=cd1e2698"
import script from "./ClingenApp.vue?vue&type=script&lang=js"
export * from "./ClingenApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports